"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ProteusError_1 = require("./ProteusError");
var DecryptError = (function (_super) {
    __extends(DecryptError, _super);
    function DecryptError(message, code) {
        if (message === void 0) { message = 'Unknown decryption error'; }
        if (code === void 0) { code = 2; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, DecryptError.prototype);
        return _this;
    }
    DecryptError.CODE = {
        CASE_200: 200,
        CASE_201: 201,
        CASE_202: 202,
        CASE_203: 203,
        CASE_204: 204,
        CASE_205: 205,
        CASE_206: 206,
        CASE_207: 207,
        CASE_208: 208,
        CASE_209: 209,
        CASE_210: 210,
        CASE_211: 211,
        CASE_212: 212,
        CASE_213: 213,
    };
    return DecryptError;
}(ProteusError_1.default));
var DuplicateMessage = (function (_super) {
    __extends(DuplicateMessage, _super);
    function DuplicateMessage(message, code) {
        if (message === void 0) { message = 'Duplicate message'; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, DuplicateMessage.prototype);
        return _this;
    }
    return DuplicateMessage;
}(DecryptError));
var InvalidMessage = (function (_super) {
    __extends(InvalidMessage, _super);
    function InvalidMessage(message, code) {
        if (message === void 0) { message = 'Invalid message'; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, InvalidMessage.prototype);
        return _this;
    }
    return InvalidMessage;
}(DecryptError));
var InvalidSignature = (function (_super) {
    __extends(InvalidSignature, _super);
    function InvalidSignature(message, code) {
        if (message === void 0) { message = 'Invalid signature'; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, InvalidSignature.prototype);
        return _this;
    }
    return InvalidSignature;
}(DecryptError));
var OutdatedMessage = (function (_super) {
    __extends(OutdatedMessage, _super);
    function OutdatedMessage(message, code) {
        if (message === void 0) { message = 'Outdated message'; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, OutdatedMessage.prototype);
        return _this;
    }
    return OutdatedMessage;
}(DecryptError));
var PrekeyNotFound = (function (_super) {
    __extends(PrekeyNotFound, _super);
    function PrekeyNotFound(message, code) {
        if (message === void 0) { message = 'Pre-key not found'; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, PrekeyNotFound.prototype);
        return _this;
    }
    return PrekeyNotFound;
}(DecryptError));
var RemoteIdentityChanged = (function (_super) {
    __extends(RemoteIdentityChanged, _super);
    function RemoteIdentityChanged(message, code) {
        if (message === void 0) { message = 'Remote identity changed'; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, RemoteIdentityChanged.prototype);
        return _this;
    }
    return RemoteIdentityChanged;
}(DecryptError));
var RemoteEncryptionError = (function (_super) {
    __extends(RemoteEncryptionError, _super);
    function RemoteEncryptionError(message, code) {
        if (message === void 0) { message = 'Sending client failed to encrypt the message'; }
        if (code === void 0) { code = DecryptError.CODE.CASE_213; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, RemoteEncryptionError.prototype);
        return _this;
    }
    return RemoteEncryptionError;
}(DecryptError));
var TooDistantFuture = (function (_super) {
    __extends(TooDistantFuture, _super);
    function TooDistantFuture(message, code) {
        if (message === void 0) { message = 'Message is from too distant in the future'; }
        var _this = _super.call(this, message, code) || this;
        Object.setPrototypeOf(_this, TooDistantFuture.prototype);
        return _this;
    }
    return TooDistantFuture;
}(DecryptError));
Object.assign(DecryptError, {
    DuplicateMessage: DuplicateMessage,
    InvalidMessage: InvalidMessage,
    InvalidSignature: InvalidSignature,
    OutdatedMessage: OutdatedMessage,
    PrekeyNotFound: PrekeyNotFound,
    RemoteEncryptionError: RemoteEncryptionError,
    RemoteIdentityChanged: RemoteIdentityChanged,
    TooDistantFuture: TooDistantFuture,
});
exports.default = DecryptError;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/errors/DecryptError.js
// module id = 46
// module chunks = 0 1